import { Controller } from '@hotwired/stimulus'
import './styles.less'

export default class extends Controller {
    static targets = ['item', 'header', 'panel']

    declare readonly headerTargets: HTMLElement[]
    declare readonly panelTargets: HTMLElement[]
    declare readonly itemTargets: HTMLElement[]

    connect() {
        this.panelTargets?.forEach((panel: HTMLElement, index: number) => {
            const expanded = this.headerTargets?.[index]?.classList.contains('is-open') === true
            panel.style.overflow = 'hidden'

            if (expanded) {
                panel.style.height = 'auto'
            } else {
                panel.style.height = '0px'
            }
        })
    }

    toggle(event: Event) {
        const header = event.currentTarget as HTMLElement
        const index = this.headerTargets?.indexOf(header)

        if (index === -1) {
            return
        }

        const panel = this.panelTargets?.[index]
        const expanded = header.classList.contains('is-open')

        header.classList.toggle('is-open', !expanded)

        if (expanded) {
            const currentHeight = panel.scrollHeight
            panel.style.height = currentHeight + 'px'
            void panel.offsetHeight
            panel.style.height = '0px'
        } else {
            panel.style.height = '0px'
            void panel.offsetHeight

            const onEnd = () => {
                panel.style.height = 'auto'
                panel.removeEventListener('transitionend', onEnd)
            }

            panel.addEventListener('transitionend', onEnd)
            panel.style.height = panel.scrollHeight + 'px'
        }
    }
}
